<template>
<div class="flex flex-col">

  <!-- <p class="mt-4 text-xs text-gray-400 uppercase">
    Step 6 of 6
  </p> -->

  <label
    for="name"
    class="flex flex-col justify-end text-xl text-gray-700 font-medium sm:text-2xl"
  >
    And lastly, how can we contact you?
  </label>

  <p class="mt-2 text-sm text-gray-500">
    Your details will only be used by The Tutor Index to contact you about your request.
    <br />
    They <strong>will not</strong> be shared with anyone else, including our tutors.
  </p>

  <div class="mt-6">
    <input 
      v-model="name"
      type="text" 
      name="name" 
      id="name" 
      autocomplete="name"
      class="block w-full max-w-sm rounded-md border-gray-300 py-3 text-base placeholder-gray-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:flex-1"
      placeholder="Name"
    />
    <p v-if="$v.name.$dirty && !$v.name.required" class="mt-1 mb-3 text-sm text-red-600">Please enter your name.</p>

    <input 
      v-model="email"
      type="email" 
      name="email" 
      id="email" 
      inputmode="email"
      autocomplete="email"
      class="mt-2 block w-full max-w-sm rounded-md border-gray-300 py-3 text-base placeholder-gray-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:flex-1"
      placeholder="Email address"
    />
    <p v-if="$v.email.$dirty && !$v.email.required" class="mt-1 mb-3 text-sm text-red-600">Please enter an email address.</p>
    <p v-if="$v.email.$dirty && !$v.email.email" class="mt-1 mb-3 text-sm text-red-600">Please enter a valid email address.</p>

    <!-- <input 
      v-model="telephone"
      type="tel" 
      name="telephone" 
      id="telephone" 
      inputmode="tel"
      autocomplete="tel"
      class="block w-full max-w-sm rounded-md border-gray-300 py-3 text-base placeholder-gray-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:flex-1"
      placeholder="Telephone"
    /> -->
  </div>

  <button 
    type="button" 
    @click="submit" 
    :disabled="submitting"
    class="mt-6 self-start inline-flex items-center gap-x-2.5 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
    :class="{ 'animate-pulse': submitting }"
  >
    <template v-if="submitting">
      Submitting…
    </template>
    <template v-else>
      Next
      <svg class="-mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
        <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z" fill="currentColor" />
      </svg>
    </template>
  </button>

</div>
</template>
<script>

import { required, email } from 'vuelidate/lib/validators'

import FindATutorService from '@/services/FindATutorService'

const findATutorService = new FindATutorService()


export default {
  props: {
    enquiry: Object,
  },
  data() {
    return {
      name: null,
      email: null,
      telephone: null,
      submitting: false,
    }
  },
  methods: {
    async submit() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.$emit('updateEnquiry', { name: this.name, email: this.email })

      this.submitting = true
      
      this.$nextTick(async () => {

        try {
          await findATutorService.submitFindMeATutorNew(this.enquiry)
          this.$router.push({ name: 'FindATutor-ThankYou' })
        }
        catch {
          alert('There seems to have been a problem. Please try again, or drop us an email to hello@thetutorindex.com and we will be more than happy to help.')
        }
        finally {
          this.submitting = false
        }
      
      })
    }
  },
  validations: {
    name: {
      required,
    },
    email: {
      required,
      email,
    }
  },
  mounted() {
    if (this.enquiry.name) this.name = this.enquiry.name
    if (this.enquiry.email) this.email = this.enquiry.email
    if (this.enquiry.telephone) this.telephone = this.enquiry.telephone
  }
}
</script>

<style lang="scss" scoped>

</style>